import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 45 45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45 45\" id=\"info\"><title>Information</title><circle cx=\"22.5\" cy=\"13.5\" r=\"2.5\" /><path d=\"M22.5 19c1.4 0 2.5 1.1 2.5 2.5v11c0 1.4-1.1 2.5-2.5 2.5S20 33.9 20 32.5v-11c0-1.4 1.1-2.5 2.5-2.5z\" /><path d=\"M22.5 45C10.1 45 0 34.9 0 22.5S10.1 0 22.5 0 45 10.1 45 22.5 34.9 45 22.5 45zm0-42C11.7 3 3 11.7 3 22.5S11.7 42 22.5 42 42 33.3 42 22.5 33.3 3 22.5 3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol